export interface PurchaseOrderValidationRequest {
  purchaseOrder: string;
  productLineCode: string;
  jobsiteId: string | number;
}
